import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { TimeBasedSettingForAllCallersRequest } from '../api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersrequest';
import { TimeBasedSettingForAllCallersResponse, TimeBasedSettingForAllCallersResponseDtoImpl } from '../api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class TimeBasedSettingForAllCallersAPIProcessorImpl extends SixdeeCRBTAPIProcessor<TimeBasedSettingForAllCallersRequest, TimeBasedSettingForAllCallersResponse>
{
    execute(request: TimeBasedSettingForAllCallersRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new TimeBasedSettingForAllCallersResponseDtoImpl(APIFeatures.TIME_BASED_SETTING_FOR_ALL_CALLERS, "Time Based Setting Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new TimeBasedSettingForAllCallersResponseDtoImpl(APIFeatures.TIME_BASED_SETTING_FOR_ALL_CALLERS, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
      
            this.getAPIFailure(new TimeBasedSettingForAllCallersResponseDtoImpl(APIFeatures.TIME_BASED_SETTING_FOR_ALL_CALLERS, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/timebasedsettingforallcallersapiprocessor.tsx